import React from 'react';

function Footer(props) {
  return (
    <div className="footer">
      <p>Ⓒ SACHIN ~ 2022 </p>
    </div>
  );
}

export default Footer;
